import React from "react";
import { Clock3 } from "lucide-react";
import { ukDayYear, ukTime } from "@/lib/time";

/** The small, quiet "Submitted 01 Nov 2026 · 12:31" under a case's name on every list — UK time. */
export const CaseStamp = ({ at, label = "Submitted", testId }) => {
  if (!at) return null;
  return (
    <div data-testid={testId} title={`${label} ${ukDayYear(at)} at ${ukTime(at)} (UK time)`}
         style={{ display: "inline-flex", alignItems: "center", gap: 5, marginTop: 6, fontSize: 11, lineHeight: 1.2,
           color: "#94a3b8", fontVariantNumeric: "tabular-nums", letterSpacing: ".01em", whiteSpace: "nowrap" }}>
      <Clock3 style={{ width: 11, height: 11, flex: "none" }} aria-hidden="true" />
      {label} {ukDayYear(at)} · {ukTime(at)}
    </div>
  );
};

export default CaseStamp;
